import { render, staticRenderFns } from "./tabCompare.vue?vue&type=template&id=74bc7d39"
import script from "./tabCompare.vue?vue&type=script&lang=js"
export * from "./tabCompare.vue?vue&type=script&lang=js"
import style0 from "./tabCompare.vue?vue&type=style&index=0&id=74bc7d39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports